import { api } from '../../config/api'
import {
  NEWS,
  POPULAR_NEWS,
  NEWS_DETAILS
} from '../../actions/actionTypes'

export const getNews = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().news.list[lang].lastUpdate || !getState().news.list[lang].data.length) {
    dispatch({ type: NEWS.REQUEST })
    return (
      fetch(api.news+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: NEWS.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: NEWS.FAILURE, error: err })
      })
    )
  }
}

export const getPoppularNews = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().news.popular[lang].lastUpdate || !getState().news.popular[lang].data.length) {
    dispatch({ type: POPULAR_NEWS.REQUEST })
    return (
      fetch(api.newsPopular+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: POPULAR_NEWS.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: POPULAR_NEWS.FAILURE, error: err })
      })
    )
  } 
}

export const getNewsDataById = (id) => (dispatch, getState) => {
  const { lang, lasted } = getState()
  dispatch({ type: NEWS_DETAILS.REQUEST, lang })
  return (
    fetch(api.news+'/'+id+'?language='+lang)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: NEWS_DETAILS.SUCCESS, data: res, lang, lasted })
    })
    .catch((err) => {
      dispatch({ type: NEWS_DETAILS.FAILURE, error: err })
    })
  )
}


// WEBPACK FOOTER //
// ./src/containers/News/actions.js